/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';

import DS from 'ember-data';

interface PopoverContentArgs {
  segmentId: number;
}

export default class PopoverContent extends Component<PopoverContentArgs> {
  @service store!: DS.Store;

  fetchSegmentTask = task({ drop: true }, async () => {
    if (!this.args.segmentId) {
      return;
    }
    return await this.store.findRecord('segment', this.args.segmentId);
  });

  constructor(owner: unknown, args: PopoverContentArgs) {
    super(owner, args);
    this.fetchSegmentTask.perform();
  }
}
